module.exports = __webpack_public_path__ + "static/media/logo_abbinarybag.6c4bf37b.svg";